<template>
  <mdb-view class="view z-depth-1">
    <mdb-mask class="mask-gradients">
      <slot>There should be content code here...</slot>
    </mdb-mask>
  </mdb-view>
</template>

<script>
import {
  mdbView,
  mdbMask
} from 'mdbvue'

export default {
  name: 'CompanyIntro',
  props: {},
  components: {
    mdbView,
    mdbMask
  }
}
</script>

<style scoped>
.view {
  background: black;
}

@-webkit-keyframes AnimationName {
    0%{background-position:0% 50%}
    50%{background-position:100% 50%}
    100%{background-position:0% 50%}
}
@-moz-keyframes AnimationName {
    0%{background-position:0% 50%}
    50%{background-position:100% 50%}
    100%{background-position:0% 50%}
}
@keyframes AnimationName { 
    0%{background-position:0% 50%}
    50%{background-position:100% 50%}
    100%{background-position:0% 50%}
}


@keyframes gradient {
  0% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.5), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.5),   
        transparent 70%
      );
  }
  
  5% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.51), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.49),   
        transparent 70%
      );
  }
  10% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.52), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.48),   
        transparent 70%
      );
  }  
  15% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.53), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.47),   
        transparent 70%
      );
  }
  20% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.54), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.46),   
        transparent 70%
      );
  }  
  25% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.55), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.45),   
        transparent 70%
      );
  }
  30% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.56), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.44),   
        transparent 70%
      );
  }  
  35% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.57), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.43),   
        transparent 70%
      );
  }
  40% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.58), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.42),   
        transparent 70%
      );
  }  
  45% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.59), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.41),   
        transparent 70%
      );
  }
  
  50% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.6), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.4),   
        transparent 70%
      );
  }
  
  55% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.59), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.41),   
        transparent 70%
      );
  }
  60% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.58), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.42),   
        transparent 70%
      );
  }  
  65% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.57), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.43),   
        transparent 70%
      );
  }
  70% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.56), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.44),   
        transparent 70%
      );
  }  
  75% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.55), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.45),   
        transparent 70%
      );
  }
  80% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.54), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.46),   
        transparent 70%
      );
  }  
  85% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.53), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.47),   
        transparent 70%
      );
  }
  90% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.52), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.48),   
        transparent 70%
      );
  }  
  95% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.51), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.49),   
        transparent 70%
      );
  }
  
  100% {
    background:
      radial-gradient(
        circle at top right,
        rgba(151, 144, 170, 0.5), 
        transparent 50%
      ),
      radial-gradient(
        at bottom left,
        rgba(123, 152, 191, 0.5),   
        transparent 70%
      );
  }
}

.mask-gradients {
   background: 
               radial-gradient( 
                 circle at top right, 
                 rgba(151, 144, 170, 0.5),  
                 transparent 50% 
               ), 
               radial-gradient( 
                 at bottom left, 
                 rgba(123, 152, 191, 0.5),    
                 transparent 70% 
               ); 
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.mask-gradients2 {
/* THIS WORKS BUT IS SLOW, THIS WAS IN USE FOR over 6 months */
  /* 
   * black
   * #7b98bf blue
   * #9790aa purple
   */
/*   background: */
/*               radial-gradient( */
/*                 circle at top right, */
/*                 rgba(151, 144, 170, 0.5),  */
/*                 transparent 50% */
/*               ), */
/*               radial-gradient( */
/*                 at bottom left, */
/*                 rgba(123, 152, 191, 0.5),    */
/*                 transparent 70% */
/*               ); */
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  
  -webkit-animation: gradient 4s ease infinite;
  -moz-animation: gradient 4s ease infinite;
  animation: gradient 4s ease infinite;
}
/* Try this instead for animation. https://codepen.io/zacharyhickson/pen/efaik */
/* https://codepen.io/romanrei/pen/oWEzqy */

.mask-gradients222 {
  /* 
   * black
   * #7b98bf blue
   * #9790aa purple
   */
  background:
              radial-gradient(
                circle at top right,
                rgba(151, 144, 170, 0.5), 
                transparent 50%
              ),
              radial-gradient(
                at bottom left,
                rgba(123, 152, 191, 0.5),   
                transparent 70%
              );
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>